import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const EventManagementPanel = ({ events, onEventAction }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');

  const statusOptions = [
    { value: 'all', label: 'Tüm Durumlar' },
    { value: 'pending', label: 'Onay Bekliyor' },
    { value: 'approved', label: 'Onaylandı' },
    { value: 'rejected', label: 'Reddedildi' }
  ];

  const filteredEvents = events?.filter(event => {
    const matchesSearch = event?.title?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
                         event?.organizer?.toLowerCase()?.includes(searchTerm?.toLowerCase());
    const matchesStatus = statusFilter === 'all' || event?.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  return (
    <div className="bg-card rounded-xl border border-border">
      <div className="p-4 md:p-6 border-b border-border">
        <h2 className="text-xl md:text-2xl font-semibold text-foreground mb-4">Etkinlik Yönetimi</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
          <Input
            type="search"
            placeholder="Etkinlik ara..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e?.target?.value)}
          />
          <Select
            options={statusOptions}
            value={statusFilter}
            onChange={setStatusFilter}
            placeholder="Durum filtrele"
          />
        </div>
      </div>
      <div className="divide-y divide-border">
        {filteredEvents?.map((event) => (
          <div key={event?.id} className="p-4 md:p-6 hover:bg-muted/30 transition-smooth">
            <div className="flex flex-col lg:flex-row gap-4">
              <Image
                src={event?.image}
                alt={event?.imageAlt}
                className="w-full lg:w-32 h-32 rounded-lg object-cover flex-shrink-0"
              />
              
              <div className="flex-1 min-w-0">
                <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-3 mb-3">
                  <div className="flex-1 min-w-0">
                    <h3 className="text-base md:text-lg font-semibold text-foreground mb-1 truncate">{event?.title}</h3>
                    <p className="text-sm text-muted-foreground mb-2">Organizatör: {event?.organizer}</p>
                    <div className="flex flex-wrap items-center gap-3 text-xs md:text-sm text-muted-foreground">
                      <span className="flex items-center gap-1 whitespace-nowrap">
                        <Icon name="Calendar" size={14} />
                        {event?.date}
                      </span>
                      <span className="flex items-center gap-1 whitespace-nowrap">
                        <Icon name="MapPin" size={14} />
                        {event?.location}
                      </span>
                      <span className="flex items-center gap-1 whitespace-nowrap">
                        <Icon name="Users" size={14} />
                        {event?.attendees} katılımcı
                      </span>
                    </div>
                  </div>
                  
                  <span className={`inline-flex items-center gap-1 px-3 py-1 rounded-md text-xs font-medium whitespace-nowrap flex-shrink-0 ${
                    event?.status === 'pending' ? 'bg-warning/10 text-warning' :
                    event?.status === 'approved'? 'bg-success/10 text-success' : 'bg-error/10 text-error'
                  }`}>
                    {event?.status === 'pending' ? 'Onay Bekliyor' : 
                     event?.status === 'approved' ? 'Onaylandı' : 'Reddedildi'}
                  </span>
                </div>

                <div className="flex flex-wrap gap-2">
                  {event?.status === 'pending' && (
                    <>
                      <Button
                        variant="success"
                        size="sm"
                        iconName="CheckCircle"
                        iconPosition="left"
                        onClick={() => onEventAction('approve', event?.id)}
                      >
                        Onayla
                      </Button>
                      <Button
                        variant="danger"
                        size="sm"
                        iconName="XCircle"
                        iconPosition="left"
                        onClick={() => onEventAction('reject', event?.id)}
                      >
                        Reddet
                      </Button>
                    </>
                  )}
                  <Button
                    variant="outline"
                    size="sm"
                    iconName="Edit"
                    iconPosition="left"
                    onClick={() => onEventAction('edit', event?.id)}
                  >
                    Düzenle
                  </Button>
                  <Button
                    variant="ghost"
                    size="sm"
                    iconName="Trash2"
                    iconPosition="left"
                    onClick={() => onEventAction('delete', event?.id)}
                    className="text-error hover:text-error"
                  >
                    Sil
                  </Button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {filteredEvents?.length === 0 && (
        <div className="p-8 md:p-12 text-center">
          <Icon name="Calendar" size={48} className="mx-auto mb-4 text-muted-foreground opacity-50" />
          <p className="text-muted-foreground">Etkinlik bulunamadı</p>
        </div>
      )}
    </div>
  );
};

export default EventManagementPanel;